module.exports = __webpack_public_path__ + "static/media/tick.85f2ba8a.svg";